import { Button as BaseButton } from '@base-ui/react/button'
import React from 'react'
import styled from 'styled-components'
import { radii } from 'sutra/tokens/radii'

export type KebabButtonSize = 'sm' | 'md' | 'lg'

export interface KebabButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  size?: KebabButtonSize
}

const sizeStyles: Record<KebabButtonSize, { box: string; radius: string }> = {
  sm: { box: '24px', radius: '6px' },
  md: { box: '28px', radius: '6px' },
  lg: { box: '36px', radius: `${radii.md}px` },
}

// Shared trigger for a card/row's overflow menu. Consolidates two previously
// near-identical copies (ask-yogi saved-prompts, trend-detection
// AgentRowKebab) that cross-feature private-import rules prevented either
// from importing directly.
export const KebabButton = React.forwardRef<
  HTMLButtonElement,
  KebabButtonProps
>(({ size = 'md', className, children, ...rest }, ref) => (
  <StyledButton
    ref={ref}
    type="button"
    $size={size}
    className={className}
    {...rest}
  >
    {children}
  </StyledButton>
))

KebabButton.displayName = 'KebabButton'

const StyledButton = styled(BaseButton)<{ $size: KebabButtonSize }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${({ $size }) => sizeStyles[$size].box};
  height: ${({ $size }) => sizeStyles[$size].box};
  border: none;
  border-radius: ${({ $size }) => sizeStyles[$size].radius};
  background: transparent;
  color: #7f8695;
  cursor: pointer;

  &:hover {
    background-color: #e2e4ea;
    color: #28364f;
  }

  &:focus-visible {
    outline: 2px solid #4c6ef5;
    outline-offset: 1px;
  }
`
